import AjaxResolver from 'owd/module/ajax';

export default class LineupResolver extends AjaxResolver {
	shouldPushState() {
		return true;
	}

	pageIn() {
		const deferred = $.Deferred();
		const lineup = $('.section--lineup');

		// $('html, body').animate({
		// 	scrollTop: `${sectionInfo.offset().top - 90}px`
		// }, 600);

		lineup.transition({
			opacity: 1
		}, 200, 'easeOutQuad', () => {
			$('.tickets-nav').css({
				'pointer-events': 'auto'
			});
			deferred.resolve();
		});

		return deferred.promise();
	}

	pageOut() {
		const deferred = $.Deferred();
		const lineup = $('.section--lineup');

		$('.tickets-nav').css({
			'pointer-events': 'none'
		});

		lineup.transition({
			opacity: 0
		}, 200, 'easeOutQuad', () => {
			deferred.resolve();
		});

		return deferred.promise();
	}

	updateContent($loadedContent) {
        const deferred = $.Deferred();
        const $newContainer = $loadedContent.find('.section--lineup');
		const $currentContainer = $('.section--lineup');
		// const $newActiveLink =  $loadedContent.find('.tickets-nav-item.active');
		// const $currentActiveLink = $('.tickets-nav-item.active');

		$newContainer.css({
			opacity: 0
		});

		$currentContainer.after($newContainer);
		$currentContainer.remove();

		deferred.resolve([$currentContainer], [$newContainer]);

		return deferred.promise();
	}
}
